const WorkRampAnalyticsAppOptions = {
  DASHBOARD: {
    id: 0,
    title: 'Dashboard',
    href: '/analytics',
    src: '/images/dashboard_icon.svg',
    sortOrder: 1,
  },
  SETUP: {
    id: 2,
    title: 'Setup',
    href: '/analytics/setup',
    src: '/images/setup_icon.svg',
    sortOrder: 2,
  },
};

export default WorkRampAnalyticsAppOptions;
